import { useEffect, useState, MouseEvent } from "react";
import { useSelector } from "react-redux";

import store, { RootState } from "@src/reducers/store";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { updateNodeSelectionNodeEditedState } from "@src/reducers/your-reducer";

import renameFolderIcon from "@src/assets/svg/rename-blue-icon.svg";
import renameFolderInactiveIcon from "@src/assets/svg/rename-inactive-blue-icon.svg";
import { useI18N } from "@src/language/language-context";

export const useControlBarRenameFolderButton = () => {
  const i18n = useI18N();
  const machineStructureNodeset = getMachineStructureNodeset();
  const [isFilterViewActive, setIsFilterViewActive] = useState(false);

  const nodeSelectionNodeData = useSelector(
    (state: RootState) => state.yourSlice.nodeSelection.nodeData,
  );

  const nodeSelectionNodeState = () =>
    store.getState().yourSlice.nodeSelection.state;

  const nodeSelectionNodeDataKey = () =>
    store.getState().yourSlice.nodeSelection.nodeData?.key || "";

  const activeMachineStructureNode = () =>
    store.getState().yourSlice.activeMachineStructureNode;

  const editRenameIsEnabled = () =>
    !isFilterViewActive &&
    activeMachineStructureNode() !== "" &&
    nodeSelectionNodeState() === "none" &&
    nodeSelectionNodeDataKey() !== "";

  const openRenameInput = (e: MouseEvent) => {
    e.preventDefault();
    store.dispatch(updateNodeSelectionNodeEditedState(true));
  };

  const disabled = !editRenameIsEnabled();
  const icon = disabled ? renameFolderInactiveIcon : renameFolderIcon;
  const tooltip = i18n("modules.machineStructurePanelControlBar.renameFolder");

  useEffect(() => {
    const updateIsFilterViewActive = () => {
      const isFiltered = machineStructureNodeset.getFilteredFlatMap().size > 0;
      setIsFilterViewActive(isFiltered);
    };

    machineStructureNodeset.addObserver(updateIsFilterViewActive);

    return () => {
      machineStructureNodeset.removeObserver(updateIsFilterViewActive);
    };
  }, [machineStructureNodeset]);

  return {
    openRenameInput,
    tooltip,
    icon,
    disabled,
    nodeSelectionNodeData,
  };
};
